var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-divider'),_c('p',[_vm._v(_vm._s(_vm.$t('fieldAgent'))+": "+_vm._s(_vm.customer.fieldAgent.name))]),_c('p',[_vm._v(_vm._s(_vm.$t('farmer'))+": "+_vm._s(_vm.customer.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }